import { useEffect, useState } from "react";
import { Download } from "lucide-react";

import {
  Banner,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@zentrack/ui";

import { isStandaloneDisplay, useInstallPrompt } from "../lib/pwa";

export function PwaInstallPanel() {
  const { canPrompt, promptInstall } = useInstallPrompt();
  const [installed, setInstalled] = useState(false);
  const [justInstalled, setJustInstalled] = useState(false);

  useEffect(() => {
    setInstalled(isStandaloneDisplay());
  }, []);

  // Refresh "installed" if the user accepts the Chromium prompt.
  useEffect(() => {
    if (!justInstalled) {
      return;
    }
    const id = window.setTimeout(() => setInstalled(isStandaloneDisplay()), 500);
    return () => window.clearTimeout(id);
  }, [justInstalled]);

  const handleInstall = async () => {
    const accepted = await promptInstall();
    if (accepted) {
      setJustInstalled(true);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Install ZenTrack</CardTitle>
        <CardDescription>
          Install ZenTrack as an app for a focused, full-window experience. It keeps working offline
          once the app shell has loaded.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {installed ? (
          <Banner
            tone="success"
            title="Running as an installed app"
            message="You're using ZenTrack in standalone mode. Local data is stored on this device."
          />
        ) : canPrompt ? (
          <Button onClick={() => void handleInstall()} type="button">
            <Download className="size-4" />
            Install ZenTrack
          </Button>
        ) : (
          <Banner
            tone="info"
            title="Install from your browser menu"
            message="On Chrome, Edge, and Brave, use the address-bar install icon or menu > Install app. On Safari (iOS/macOS), use Share > Add to Dock / Add to Home Screen."
          />
        )}
      </CardContent>
    </Card>
  );
}
